import styled, { css } from 'styled-components';

export const ComplaintsTable = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 70px;
  grid-column-gap: 15px;
  justify-content: space-between;
  padding: 0 15px;
  border-bottom: ${({ heading, theme }) =>
    heading && `1px solid ${theme.colors.border.secondary}`};

  :nth-of-type(even) {
    background-color: ${({ heading }) => !heading && `#f8f9fc`};
  }
  /* Align last three columns to center */
  & > :nth-child(n + 0) {
    justify-self: center;
  }
  /* Alignment for the very last column */
  & > :last-child {
    display: flex;
    justify-self: start;
    align-items: center;
  }
`;
